import { createAction, props } from '@ngrx/store';

import {
  AccessRule,
  Application,
  ApplicationGroup,
  NewRole,
} from '../../../shared/models/authorizationService.model';
import { AutoSuggestProfile } from '../../../shared/models/autoSuggest.model';
import { B2CProfile } from '../../models/profile.model';
import { UserProfile } from '../../models/userProfile.model';

export const autoSuggestProfiles = createAction(
  '[Profile] AutoSuggest Profiles',
  props<{ searchtext: string }>(),
);

export const autoSuggestProfilesSuccess = createAction(
  '[Profile] AutoSuggest Profiles success',
  props<{ autoSuggest: AutoSuggestProfile }>(),
);

export const searchProfilesRequest = createAction(
  '[Profile] Get Profiles',
  props<{ searchtext: string }>(),
);

export const searchProfilesSuccess = createAction(
  '[Profile] Load profile success',
  props<{ profile: UserProfile }>(),
);

export const searchProfileNotFound = createAction('[Profile] Load profile not found');

export const initAuthorization = createAction(
  '[Profile] Init authorization',
  props<{ profileId: number }>(),
);

export const clearProfileResult = createAction('[Profile] Clear Profile Result');

export const setApplications = createAction(
  '[Profile] Set applications',
  props<{ applications: Application[] }>(),
);
export const setApplicationGroups = createAction(
  '[Profile] Set application groups',
  props<{ applicationGroups: ApplicationGroup[] }>(),
);
export const setAccessRules = createAction(
  '[Profile] Set access rules',
  props<{ accessRules: AccessRule[] }>(),
);
export const setUseraccess = createAction(
  '[Profile] Set user access',
  props<{ applicationKey: string; roleKey: string }>(),
);
export const setRoles = createAction('[Profile] Set roles', props<{ roles: NewRole[] }>());

export const b2cProfileNotFound = createAction(
  '[Profile] Get profile B2C profile not found',
  props<{ profile: B2CProfile }>(),
);
